import React, { useEffect, useRef } from 'react';
import useScrollTarget from '../../hooks/useScrollTarget';

import './sticky-bar.less';

export default function StickyBar({
    id,
    children,
    height,
    onStickyChange,
    isInfiniteScroll,
    dynamicHeight = true,
    className,
    backgroundColor,
    disableHeightAssignment
}) {
    const inRange = useScrollTarget(id, undefined, undefined, 0);
    const childRef = useRef(null);
    const style = backgroundColor ? { backgroundColor } : null;
    //if dynamicHeight, height will be calculated based on the height of the
    //children using a ref to prevent layout shift when it becomes sticky
    let styleHeight =
        height == null && dynamicHeight && childRef && childRef.current ? childRef.current.clientHeight + 'px' : height;
    useEffect(() => {
        if (typeof onStickyChange === 'function') {
            onStickyChange(inRange);
        }
    }, [inRange]);

    return (
        <div
            id={id}
            className={`stickyContainer${isInfiniteScroll ? ' infinite' : ''}${className ? ' ' + className : ''}`}
            {...!disableHeightAssignment && {style: { height: styleHeight }}}
        >
            <div className={`stickyBar${inRange ? ' fixed' : ''}`} ref={childRef} style={style}>
                {typeof children === 'function' ? children({ inRange }) : children}
            </div>
        </div>
    );
}
